import useToken from "../customhooks/useToken";

const Token = () => {
  const { token } = useToken();

  return <div className="token">token:"{token}"</div>;
};

export default Token;
